import { TEST_MODE, localStorageGet } from './utils'
import { getComponentContext } from './controllerHelpers/utils'

const URL = `https://ierxexdtyashuotcsjyo.supabase.co/functions/v1/send_message_to_slack`
const ENV = TEST_MODE ? 'Dev' : 'Prod'

export const MIGRATION_ISSUES_CHANNEL_ID = 'C0684B0CUF8'

export default async function notify(
  text: string,
  customChannelId?: string,
  contextData?: Record<string, string | number | boolean | null | undefined>,
  error?: { response?: { data: string }; message: string },
  self?: string | object,
  window?: Window | null
) {
  if (
    ((window && window.location.toString().startsWith('file:///')) || TEST_MODE) &&
    !(window && window.location.search.includes('is_stripe_test=true'))
  )
    return
  const context = self ? getComponentContext(self) : null
  const userData = context
    ? JSON.parse(localStorageGet('SavvyFormUserData') || '{}')[Number(context.flowId)] || {}
    : null
  const contextString = context
    ? [
        { name: 'Flow Id', value: context.flowId },
        { name: 'Flow Version', value: context.flowVersion },
        {
          name: 'Page',
          value: context.pageEl?.getAttribute('data-page-page-key') || context.pageId,
        },
        { name: 'Component', value: context.component?.key || context.componentId },
        { name: 'Flow Version', value: context.flowVersion },
        { name: 'Entry Id', value: userData.entryId },
      ]
        .filter((e) => e.value)
        .map((e) => `${e.name}: ${e.value}`)
        .join(' | ')
    : null
  let message = error
    ? text
    : `${ENV} Error (Stimulus) at ${window && window.location.toString()} - ${text}`
  if (error)
    message += `: ${
      error && error.response && error.response.data
        ? JSON.stringify(error.response.data)
        : error.message
    }`
  if (contextString && contextString.length > 0) message += `\n\n${contextString}`
  if (contextData)
    message += `\n\n${Object.entries(contextData)
      .map(([k, v]) => `- \`${k}\`: \`${v}\``)
      .join('\n')}`
  const channelId = customChannelId || getChannelId(context, message)
  await fetch(URL, {
    method: 'POST',
    body: JSON.stringify({ message, channel_id: channelId }),
    headers: {
      apikey:
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImllcnhleGR0eWFzaHVvdGNzanlvIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NjQ4ODU2NDIsImV4cCI6MTk4MDQ2MTY0Mn0.AbUQz18lps79WZBW1kmbFP2lUTiAF6ttTuFK14yvUuw',
      authorization:
        'Bearer eyJhbGciOiJIUzI1NiIsImtpZCI6IklVZnFVRnhXNnZOQU0vQkQiLCJ0eXAiOiJKV1QifQ.eyJhdWQiOiJhdXRoZW50aWNhdGVkIiwiZXhwIjoxNzAxNzA5MzU3LCJpYXQiOjE3MDExMDQ1NTcsImlzcyI6Imh0dHBzOi8vaWVyeGV4ZHR5YXNodW90Y3NqeW8uc3VwYWJhc2UuY28vYXV0aC92MSIsInN1YiI6ImZkNWJiOWJlLTNiOWMtNDg1Ni05ZDgxLTdhNzMxYzAyMjBhMyIsImVtYWlsIjoiamVyZW15QGhleXNhdnZ5LmNvbSIsInBob25lIjoiIiwiYXBwX21ldGFkYXRhIjp7InByb3ZpZGVyIjoiZW1haWwiLCJwcm92aWRlcnMiOlsiZW1haWwiLCJnb29nbGUiXX0sInVzZXJfbWV0YWRhdGEiOnt9LCJyb2xlIjoiYXV0aGVudGljYXRlZCIsImFhbCI6ImFhbDEiLCJhbXIiOlt7Im1ldGhvZCI6Im90cCIsInRpbWVzdGFtcCI6MTcwMDI3Mjg5MH1dLCJzZXNzaW9uX2lkIjoiMDZmYjllODgtYmFiYS00ZGFiLWI0MTAtNDIxNDMxZWE0ZDk4In0.qZRZMHlEBQ7NmZv-nhV8PIO-Tn_JbOlIV0g-_EtQiMc',
      'Content-Type': 'application/json',
    },
  })
    .then((res) => {
      console.log('notify.ts called send_message_to_slack - response:', res)
    })
    .catch((err) => {
      console.error('ERROR with notify.ts calling send_message_to_slack:', err)
    })
}

// deno-lint-ignore no-explicit-any
function getChannelId(context: Record<string, any> | null, message: string) {
  if (ENV === 'Dev') return `C01527NKEF6`
  if (message.includes('Failed to fetch')) return `C0269MX9ETB`
  if (!context) return `G012HKB0XQE`
  if (context.datadump) return `C021S60JJPM`
  if (context.failedFetch) return `C0269MX9ETB`
  if (context.channel) return context.channel
  return `G012HKB0XQE`
}
